import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { ICustomUrlDto } from '@core/interfaces/custom-url-dto.interface';
import { ApiService } from '@core/services/api.service';
import { ApiServiceHolder } from '@core/utils/api-service-holder';
import { RESPONSE } from '@shared/tokens/server.token';
import { Observable, catchError, map, of } from 'rxjs';
import { environment } from 'src/environments/environment';

import { RedirectService } from '@shared/services/redirect.service';
import { Response } from 'express';

@Injectable({
  providedIn: 'root'
})
export class CustomUrlGuard  {

  constructor(private _api: ApiService, private _router: Router,
    @Inject(PLATFORM_ID) private _platformId: Object,
    @Optional() @Inject(RESPONSE) private response: Response,
    private router: Router,
    private redirectService: RedirectService,

) {}

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (segments.length == 0) return false;

    let lang: string | null = null;

    let customUrl: string = '';
    segments.forEach((segment, i) => {
      if (i === 0 && ['it', 'en'].includes(segment.path)) {
        lang = segment.path;
        return;
      }
      customUrl += `/${segment.path}`;
    });

    return this._api.request<ICustomUrlDto>(ApiServiceHolder.customUrl.getByUrl(`${environment.APPOrigin}${customUrl}`)).pipe(
      map(response => {

        if (!response) {
          this.navigateTo('home', lang);
          return false;
        }

        const realUrlWithoutWWW = response.realUrl.replace('www.','');
        const appOriginWithoutWWW = environment.APPOrigin.replace('www.','');

        if (response.type === 'Event') {
          this.navigateTo(`eventnow/${response.realUrl}`, lang);
        } else if (realUrlWithoutWWW.includes(appOriginWithoutWWW)) {
          let newRoute: string = realUrlWithoutWWW.replace(appOriginWithoutWWW, '');
          this.navigateTo(newRoute.slice(1), lang);
        } else {
          this.navigateTo('home', lang);
          return false;
        }

        return true
      }),
      catchError((error) =>
        of(error).pipe(
          map(() => {
            this.navigateTo('home', lang);
            return false;
          }),
        )
      )
    )
  }

  navigateTo(route: string, lang: string) {
    if (lang && route !== 'home') {
      this.redirectService.redirect(route, 302, lang);
      return;
    }

    if (lang) {
      this.router.navigate([lang, route]);
      return;
    }

    this.router.navigate([route]);
  }

}
